import { NextPartyCodeResponse, PartyList, PartyResponse, } from '@aeris/contracts';
import { request } from "./client.js";
/**
 * `/api/v1/parties` — clientes, fornecedores e transportadoras: um cadastro só,
 * carregando papéis.
 *
 * "Remover" aqui é arquivar no servidor, e por isso é POST e não DELETE: o
 * papel da aplicação não tem DELETE em nenhuma tabela de party (Master
 * Specification seção 30).
 */
// One set of endpoints, not one for customers and one for suppliers. Master
// Specification section 10.
/** Built field by field, for the same reason as the product one above. */
const partySearchParams = (query) => {
    const params = new URLSearchParams();
    if (query.search !== undefined && query.search.length > 0) {
        params.set('search', query.search);
    }
    if (query.status !== undefined)
        params.set('status', query.status);
    if (query.role !== undefined)
        params.set('role', query.role);
    // O servidor lê 'true'/'false' como texto: uma query string não carrega
    // booleano, e `String(false)` seria lido como presente e verdadeiro por
    // qualquer leitura ingênua do outro lado.
    if (query.system !== undefined)
        params.set('system', String(query.system));
    /*
     * Os filtros de coluna (F152) e a carteira (F210). Os dois primeiros eram
     * montados pela tela e largados aqui: o filtro de cidade nunca chegava ao
     * servidor.
     */
    if (query.kind !== undefined)
        params.set('kind', query.kind);
    if (query.city !== undefined && query.city.length > 0) {
        params.set('city', query.city);
    }
    if (query.salesperson !== undefined) {
        params.set('salesperson', query.salesperson);
    }
    if (query.page !== undefined)
        params.set('page', String(query.page));
    if (query.pageSize !== undefined) {
        params.set('pageSize', String(query.pageSize));
    }
    if (query.sort !== undefined)
        params.set('sort', query.sort);
    if (query.direction !== undefined)
        params.set('direction', query.direction);
    // Omitido quando vazio: `include=` sem nada faria o servidor ler um nome vazio.
    if (query.include !== undefined && query.include.length > 0) {
        params.set('include', query.include.join(','));
    }
    const encoded = params.toString();
    return encoded.length > 0 ? `?${encoded}` : '';
};
export const fetchParties = async (query, signal) => PartyList.parse(await request(`/api/v1/parties${partySearchParams(query)}`, { signal }));
export const fetchParty = async (id, signal) => PartyResponse.parse(await request(`/api/v1/parties/${id}`, { signal }));
/** O próximo código de cliente, sem reservar (F211). */
export const fetchNextPartyCode = async (signal) => NextPartyCodeResponse.parse(await request('/api/v1/parties/next-code', { signal })).code;
export const createParty = async (input) => PartyResponse.parse(await request('/api/v1/parties', { method: 'POST', body: input }));
export const updateParty = async (id, input) => PartyResponse.parse(await request(`/api/v1/parties/${id}`, { method: 'PATCH', body: input }));
export const archiveParty = async (id, version) => PartyResponse.parse(await request(`/api/v1/parties/${id}/archive`, {
    method: 'POST',
    body: { version },
}));
export const restoreParty = async (id, version) => PartyResponse.parse(await request(`/api/v1/parties/${id}/restore`, {
    method: 'POST',
    body: { version },
}));
export const addPartyAddress = async (id, input) => PartyResponse.parse(await request(`/api/v1/parties/${id}/addresses`, {
    method: 'POST',
    body: input,
}));
export const updatePartyAddress = async (id, addressId, input) => PartyResponse.parse(await request(`/api/v1/parties/${id}/addresses/${addressId}`, {
    method: 'PUT',
    body: input,
}));
/**
 * "Remove" here, archive on the server.
 *
 * A POST rather than a DELETE, because the application role holds no DELETE on
 * any party table (Master Specification section 30) and a verb promising
 * deletion would describe something the product deliberately cannot do.
 */
export const removePartyAddress = async (id, addressId, version) => PartyResponse.parse(await request(`/api/v1/parties/${id}/addresses/${addressId}/remove`, {
    method: 'POST',
    body: { version },
}));
export const addPartyContact = async (id, input) => PartyResponse.parse(await request(`/api/v1/parties/${id}/contacts`, {
    method: 'POST',
    body: input,
}));
export const updatePartyContact = async (id, contactId, input) => PartyResponse.parse(await request(`/api/v1/parties/${id}/contacts/${contactId}`, {
    method: 'PUT',
    body: input,
}));
export const removePartyContact = async (id, contactId, version) => PartyResponse.parse(await request(`/api/v1/parties/${id}/contacts/${contactId}/remove`, {
    method: 'POST',
    body: { version },
}));
//# sourceMappingURL=parties.js.map